<div *ngIf="false">
<div class="" style="background-color: white;height: 100%;">
    <!-- Header Section -->
    <h1 class="pt-4"> Trip</h1>
  
    <!-- Employee Information Section -->
    <div class="employee-info ">
      <h2>Employee Information</h2>
      <div >
        <div class="info-item">
            <!-- <mat-icon st>person</mat-icon> -->
          <img src="assets/images/employ.png" width="200px"  />
          
        </div>
        <div class="info-item infoPadding">
          <p><strong>Employee Name : </strong> {{userInformation?.user?.name||'-'}}</p>
          <p><strong class="labelWidth">Email &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: </strong>{{userInformation?.user?.email||'-'}}</p>
          <p><strong>Contact No &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: </strong> {{userInformation?.user?.mobile||'-'}}</p>

        </div>
        <div class="info-item infoPadding">
            <p><strong>Employee ID : </strong> {{userInformation?.userBookingProfile?.employeeCode||'-'}}</p>
            <p><strong>Designation &nbsp;: </strong> {{userInformation?.userBookingProfile?.userBookingProfile||'-'}}</p>
            <p><strong>Department &nbsp;: </strong> {{userInformation?.userBookingProfile?.department||'-'}}</p>
        
        </div>
        <div class="info-item infoPadding">
            <p><strong>Reporting To:</strong> {{'-'}}</p>
            <p><strong>Approver &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</strong> {{approver||'-'}}</p>
        </div>
      </div>
    </div>
  
    <!-- Travel Favourite Requests Section -->
    <!-- <div class="travel-requests">
      <h3>Travel Favourite Requests</h3>
      <table>
        <tr>
          <th>Sr. No.</th>
          <th>Name</th>
          <th>Delete</th>
        </tr>
      </table>
    </div> -->
  
    <!-- Travel Details Section -->
    <h2>Trip Information</h2>

    <div class="d-flex justify-content-center  " style="background-color: #00d1d1;height:auto">
    <div class="travel-details col-md-12 row mt-2">
        <!-- <div>
            <label for="travelType">Travel Type:</label>
            <select id="travelType">
              <option value="Domestic">Domestic</option>
              <option value="International">International</option>
            </select>
          </div> -->
          <div  *ngIf="tripResponse" >

          <div class="info-item ">
            <p><strong>Trip Name : </strong> {{tripResponse?.tripName||'-'}}</p>
        
        </div>
        <div class="info-item ">
          <p><strong>Trip For &nbsp;: </strong> {{tripResponse?.tripFor||'-'}}</p>
      
      </div>
      <div class="info-item ">
        <p><strong>Trip Purpose &nbsp;: </strong> {{tripResponse?.tripPurpose||'-'}}</p>
    
    </div>
    
        <div  class="info-item ">
        </div>
        </div>
        <div  *ngIf="tripResponse"  >

        <div  class="info-item ">
          <p><strong>Trip Discription:</strong> {{tripResponse?.tripDescription||'-'}}</p>
      </div>
      <div  class="info-item ">
        
        <button *ngIf="!showAddNew"  mat-button style="color: white;" (click)="AddNew()" color="primary"><mat-icon>keyboard_arrow_down</mat-icon>Add New</button>
        <button *ngIf="showAddNew" mat-button style="color: white;" (click)="addNewClose()" color="primary"><mat-icon>keyboard_arrow_up</mat-icon>Add New</button>

    </div>
    <div  class="info-item ">


  </div>
  <div  class="info-item ">


</div>
    </div>
          <!-- Request For Section (Converted to Select Box) -->
          <div *ngIf="showAddNew" class="col-md-12 row">
          <div class="col-md-3">
            <mat-form-field  class="col-md-12" appearance="outline">
                <mat-label>Trip Name</mat-label>
                <input  matInput name="name"  [(ngModel)]="tripRequest.tripName" >
              </mat-form-field>
            
          </div>
          <div class="col-md-3">
           
            <mat-form-field  class="col-md-12" appearance="outline">
                <mat-label>Trip For</mat-label>
                <mat-select matNativeControl name="requestFor" [(ngModel)]="tripRequest.tripFor">
                    <mat-option value="Self">Self</mat-option>
                    <mat-option value="On Behalf Of">On Behalf Of</mat-option>
                    <mat-option value="Other">Other (Non-Employee)</mat-option>
                  </mat-select>
              </mat-form-field>
          </div>
        
          <!-- Purpose Section (Already a Select Box) -->
          <div class="col-md-3">
            <mat-form-field  class="col-md-12" appearance="outline">
                <mat-label>Trip Purpose</mat-label>
                <mat-select matNativeControl name="purpose" [(ngModel)]="tripRequest.tripPurpose">
                    <mat-option value="Meeting">Meeting</mat-option>
                  </mat-select>
              </mat-form-field>
            
          </div>
          <div class="col-md-3">
            <div class="trip-button ">
                <button (click)="createTrip()" [disabled]="tripDisabled">Select Trip</button>
              </div>
</div>
          <div class="col-md-8">
            <mat-form-field  class="col-md-12" appearance="outline">
                <mat-label>Trip Discription</mat-label>
                <textarea  matInput name="discription" id="" [(ngModel)]="tripRequest.tripDescription" cols="30" rows="1"></textarea>
              </mat-form-field>
            
          </div>
          <div class="col-md-12">
</div>
          
         </div>
    </div>
  
</div>
    
  </div>
    
  <div *ngIf="!showAddNew" class="trip-table-container">
    <div class="filter-section row">
      <mat-form-field class="col-md-3">
        <mat-label>Select Trip - Name</mat-label>
        <input matInput placeholder="Trip Name" [(ngModel)]="tripName" />
      </mat-form-field>
  
      <mat-form-field class="col-md-3">
        <mat-label>ID</mat-label>
        <input matInput placeholder="Trip ID" [(ngModel)]="tripID" />
      </mat-form-field>
  <div class="col-md-2">
      <button mat-button (click)="onSelect()">Select</button>
    </div>
    <div class="col-md-2">
      <!-- <button  mat-button color="primary">Add New</button> -->
    </div>
    </div>
  <div style="overflow-y: auto; max-height: 50vh;">
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 " >
  
      <!-- Trip Duration Column -->
      <ng-container matColumnDef="tripDuration">
        <th mat-header-cell *matHeaderCellDef> Trip Duration </th>
        <td mat-cell *matCellDef="let element"> {{ element.tripDuration }} </td>
      </ng-container>
  
      <!-- Existing Trip Name Column -->
      <ng-container matColumnDef="tripName">
        <th mat-header-cell *matHeaderCellDef> Trip Name </th>
        <td mat-cell *matCellDef="let element"> {{ element.tripName }} </td>
      </ng-container>
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef> Status </th>
        <td mat-cell *matCellDef="let element"> {{ element.status }} </td>
      </ng-container>
      <!-- Trip ID Column -->
      <ng-container matColumnDef="tripID">
        <th mat-header-cell *matHeaderCellDef> Trip ID </th>
        <td mat-cell *matCellDef="let element"> {{ element.tripId }} </td>
      </ng-container>
  
      <!-- Action Column -->
      <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef></th>
        <td mat-cell *matCellDef="let element">
          <button mat-button color="accent" (click)="selectTrip(element)">Select</button>
        </td>
      </ng-container>
  
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>
    <!-- <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator> -->
  </div>
</div>
<div class="trip-container">
  <!-- Sidebar -->
  <div class="sidebar">
    <h3>Trip </h3>
    <ul>
      <li (click)="onClick('employee')" [class]="selectActiveTab==='employee'?('active'):''">Create Trip</li>
      <!-- <li (click)="onClick('policies')" [class]="selectActiveTab==='policies'?('active'):''">Policies</li> -->
      <li (click)="onClick('tripInfo')" [class]="selectActiveTab==='tripInfo'?('active'):''">Trip Information</li>
    </ul>
  </div>

  <!-- Main Content -->
  <div  class="content" *ngIf="selectActiveTab==='employee'" style="overflow-y: auto;">
    <div class="employee-info " >
      <!-- <h2 class="mt-3">Profile Info</h2> -->
      <!-- <div class="info-card " style="padding-top: 30px;">
        <div class="info-item">
          <img src="assets/images/employ.png" width="200px"  />
        </div>
        <div class="info-item infoPadding">
          <p><strong>Employee Name : </strong> {{userInformation?.user?.name||'-'}}</p>
          <p><strong class="labelWidth">Email &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: </strong>{{userInformation?.user?.email||'-'}}</p>
          <p><strong>Contact No &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;: </strong> {{userInformation?.user?.mobile||'-'}}</p>

        </div>
        <div class="info-item infoPadding">
            <p><strong>Employee ID : </strong> {{userInformation?.userBookingProfile?.employeeCode||'-'}}</p>
            <p><strong>Designation &nbsp;: </strong> {{userInformation?.userBookingProfile?.userBookingProfile||'-'}}</p>
            <p><strong>Department &nbsp;: </strong> {{userInformation?.userBookingProfile?.department||'-'}}</p>
        
        </div>
        <div class="info-item infoPadding">
            <p><strong>Reporting To:</strong> {{'-'}}</p>
            <p><strong>Approver &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;:</strong> {{approver||''}}</p>
        </div>
      </div> -->
      <div class="row">
     <app-trip-search-request></app-trip-search-request>
     </div>
      <!-- <app-flight ></app-flight> -->







    </div>
  
  </div>
  <div class="content" *ngIf="selectActiveTab==='policies'">

  </div>
  
  <div class="content" *ngIf="selectActiveTab==='tripInfo'">
    <mat-tab-group mat-stretch-tabs="false" mat-align-tabs="start" class="pb-2" style="text-align: left;">
      <mat-tab  >
        <!-- [matBadge]="airList.length||0" -->
          <ng-template mat-tab-label>
              My Trip&nbsp;<span  matBadgeSize="medium" matBadgeOverlap="false"> </span>
            </ng-template> 
            
            
    <h4  class="mt-3">Upcoming Trips</h4>

    <!-- Filters -->
    <div class="filters">
      <button mat-button (click)="refreshStatus('')"    [ngClass]="{'activeTrip': tripStatus === ''}">All</button>
      <button mat-button (click)="refreshStatus('I')"  [ngClass]="{'activeTrip': tripStatus === 'I'}">Pending</button>
      <button mat-button (click)="refreshStatus('A')"   [ngClass]="{'activeTrip': tripStatus === 'A'}">Approved</button>

      <!-- <button *ngIf="!showAddNew"  mat-raised-button style="color: white;" (click)="AddNew()" color="primary"><mat-icon>keyboard_arrow_down</mat-icon>Add New</button>
      <button *ngIf="showAddNew" mat-raised-button style="color: white;" (click)="addNewClose()" color="primary"><mat-icon>keyboard_arrow_up</mat-icon>Add New</button> -->

    </div>
    <!-- <div *ngIf="showAddNew" class="col-md-12 row shadow" style="padding-top:6px;border-radius: 4px;">
      <div class="col-md-3">
        <mat-form-field  class="col-md-12" appearance="outline">
            <mat-label>Trip Name *</mat-label>
            <input  matInput name="name"  [(ngModel)]="tripRequest.tripName" >
          </mat-form-field>
        
      </div>
      
      <div class="col-md-3">
       
        <mat-form-field  class="col-md-12" appearance="outline">
            <mat-label>Trip For *</mat-label>
            <mat-select matNativeControl name="requestFor" [(ngModel)]="tripRequest.tripFor">
                <mat-option value="Self">Self</mat-option>
                <mat-option value="On Behalf Of">On Behalf Of</mat-option>
                <mat-option value="Other">Other (Non-Employee)</mat-option>
              </mat-select>
          </mat-form-field>
      </div>
    
      <div class="col-md-3">
        <mat-form-field  class="col-md-12" appearance="outline">
            <mat-label>Trip Purpose *</mat-label>
            <mat-select matNativeControl name="purpose" [(ngModel)]="tripRequest.tripPurpose">
                <mat-option value="Meeting">Meeting</mat-option>
              </mat-select>
          </mat-form-field>
        
      </div>
      <div class="col-md-3">
        <div class="trip-button ">
            <button (click)="createTrip()"  mat-raised-button [disabled]="disabled()" color="primary">Create Trip</button>
          </div>
</div>
<div *ngIf="tripRequest.tripFor==='On Behalf Of'" class="col-md-3">
  <mat-form-field   class="col-md-12" appearance="outline">
      <mat-label>Traveller Name *</mat-label>
      <input  matInput name="name"  [(ngModel)]="tripRequest.travellerName" >
    </mat-form-field>
  
</div>
      <div class="col-md-8">
        <mat-form-field  class="col-md-12" appearance="outline">
            <mat-label>Trip Discription</mat-label>
            <textarea  matInput name="discription" id="" [(ngModel)]="tripRequest.tripDescription" cols="30" rows="1"></textarea>
          </mat-form-field>
        
      </div>
      <div class="col-md-12">
</div>
      
     </div> -->
    <!-- Trip Table -->
    <div style="overflow-y: auto; max-height: 50vh;">

    <table  mat-table [dataSource]="dataSource" class="mat-elevation-z8">
      <!-- Date Column -->
      <ng-container matColumnDef="date">
        <th mat-header-cell *matHeaderCellDef>Trip Duration</th>
        <td mat-cell *matCellDef="let request">{{ request?.tripDuration }}</td>
      </ng-container>

      <!-- Employee Column -->
      <ng-container matColumnDef="employee">
        <th mat-header-cell *matHeaderCellDef>Trip Name</th>
        <td mat-cell *matCellDef="let request">{{ request?.tripName }}</td>
      </ng-container>

      <!-- Trip Column -->
      <ng-container matColumnDef="trip">
        <th mat-header-cell *matHeaderCellDef>Trip ID</th>
        <td mat-cell *matCellDef="let request" >{{ request?.tripUid }}</td>
      </ng-container>

      <!-- Cost Column -->
      <ng-container matColumnDef="cost">
        <th mat-header-cell *matHeaderCellDef>Cost</th>
        <td mat-cell *matCellDef="let request">${{ request?.cost }}</td>
      </ng-container>

      <!-- Status Column -->
      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>Status</th>
        <td mat-cell *matCellDef="let request">
          <span class="status">{{ request?.statusDesc }}</span>
        </td>
      </ng-container>

      <!-- Actions Column -->
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef>Actions</th>
        <td mat-cell *matCellDef="let request">
          <span  class=" actions" (click)="onManageClick(request)" >Manage Trip</span>
        </td>
      </ng-container>

      <!-- Header & Rows -->
      <tr mat-header-row *matHeaderRowDef="displayedColumn"></tr>
      <tr class="mat-row" *matNoDataRow>
        <td  class="mat-cell" colspan="4">There is no data in this table</td>
        </tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumn;"></tr>
    </table>
    </div>


    <h4 class="mt-3">Past Trips</h4>

  
</mat-tab>
<mat-tab  >
  <!-- [matBadge]="airList.length||0" -->
    <ng-template mat-tab-label>
        My Team Trips&nbsp;<span  matBadgeSize="medium" matBadgeOverlap="false"> </span>
      </ng-template> 
      
      
<h4  class="mt-3">Upcoming Trips</h4>

<!-- Filters -->
<div class="filters">
<button mat-button (click)="refreshApprovalStatus('')" [ngClass]="{'activeTrip': tripApprovalStatus === ''}">All</button>
<!-- <button mat-raised-button>Pending</button> -->
<button mat-button (click)="refreshApprovalStatus('A')" [ngClass]="{'activeTrip': tripApprovalStatus === 'A'}">Approved</button>
<button mat-button (click)="refreshApprovalStatus('I')" [ngClass]="{'activeTrip': tripApprovalStatus === 'I'}">Pending for my Approval </button>

<!-- <button *ngIf="!showAddNew"  mat-raised-button style="color: white;" (click)="AddNew()" color="primary"><mat-icon>keyboard_arrow_down</mat-icon>Add New</button>
<button *ngIf="showAddNew" mat-raised-button style="color: white;" (click)="addNewClose()" color="primary"><mat-icon>keyboard_arrow_up</mat-icon>Add New</button> -->

</div>

<!-- Trip Table -->
<div style="overflow-y: auto; max-height: 50vh;">

<table  mat-table [dataSource]="ApprovalSource" class="mat-elevation-z8">
<!-- Date Column -->
<ng-container matColumnDef="date">
  <th mat-header-cell *matHeaderCellDef>Trip Duration</th>
  <td mat-cell *matCellDef="let request">{{ request?.tripDuration }}</td>
</ng-container>

<!-- Employee Column -->
<ng-container matColumnDef="employee">
  <th mat-header-cell *matHeaderCellDef>Trip Name</th>
  <td mat-cell *matCellDef="let request">{{ request?.tripName }}</td>
</ng-container>

<!-- Trip Column -->
<ng-container matColumnDef="trip">
  <th mat-header-cell *matHeaderCellDef>Trip ID</th>
  <td mat-cell *matCellDef="let request" >{{ request?.tripUid }}</td>
</ng-container>

<!-- Cost Column -->
<ng-container matColumnDef="cost">
  <th mat-header-cell *matHeaderCellDef>Cost</th>
  <td mat-cell *matCellDef="let request">${{ request?.cost }}</td>
</ng-container>

<!-- Status Column -->
<ng-container matColumnDef="status">
  <th mat-header-cell *matHeaderCellDef>Status</th>
  <td mat-cell *matCellDef="let request">
    <span class="status">{{ request?.statusDesc }}</span>
  </td>
</ng-container>

<!-- Actions Column -->
<ng-container matColumnDef="actions">
  <th mat-header-cell *matHeaderCellDef>Actions</th>
  <td mat-cell *matCellDef="let request">
    <span  class=" actions" (click)="onViewClick(request)" >View Trip</span>
  </td>
</ng-container>

<!-- Header & Rows -->
<tr mat-header-row *matHeaderRowDef="displayedColumn"></tr>
<tr class="mat-row" *matNoDataRow>
  <td  class="mat-cell" colspan="4">There is no data in this table</td>
  </tr>
<tr mat-row *matRowDef="let row; columns: displayedColumn;"></tr>
</table>
</div>




</mat-tab>

</mat-tab-group>
</div>
</div>

  